export { default } from "./resizable";
